const getMlbNative = () => {

    if (typeof window === 'undefined') {

        return {};

    }

    const mlbNative = window.__VIDEO_MLB_NATIVE__ || {};
    return mlbNative;

};

export default getMlbNative;
